import React from 'react'
import { css } from '@emotion/react'
import ubuntuLightItalic from 'common/presentation/fonts/Ubuntu-LightItalic.ttf'
import ubuntuMediumItalic from 'common/presentation/fonts/Ubuntu-MediumItalic.ttf'
import ubuntuBoldItalic from 'common/presentation/fonts/Ubuntu-BoldItalic.ttf'
import ubuntuLight from 'common/presentation/fonts/Ubuntu-Light.ttf'
import ubuntuRegular from 'common/presentation/fonts/Ubuntu-Regular.ttf'
import ubuntuMedium from 'common/presentation/fonts/Ubuntu-Medium.ttf'
import ubuntuBold from 'common/presentation/fonts/Ubuntu-Bold.ttf'

export const PreloadedFonts = React.memo(() => {
	return (
		<div
			css={css`
				/*
				 * Kept in the render tree but clipped to nothing: the text has to
				 * be laid out for the browser to actually fetch each face, so
				 * "display: none" and "visibility: hidden" would defeat the whole
				 * point of preloading.
				 *
				 * It used to hide each line with "position: fixed; top: -1000px",
				 * which only works while no ancestor creates a containing block.
				 * Mounted inside a panel that animates with "transform", the
				 * fixed positioning resolved against that panel instead of the
				 * viewport and all seven lines landed on screen, stacked on top
				 * of one another. Clipping does not care what any ancestor does.
				 */
				position: absolute;
				width: 1px;
				height: 1px;
				overflow: hidden;
				clip-path: inset(50%);
				white-space: nowrap;
				@font-face {
					font-family: 'Ubuntu';
					font-style: italic;
					font-weight: 300;
					font-display: swap;
					src: local('Ubuntu Light Italic'), local('Ubuntu-LightItalic'),
						url(${ubuntuLightItalic}) format('truetype');
				}
				@font-face {
					font-family: 'Ubuntu';
					font-style: italic;
					font-weight: 500;
					font-display: swap;
					src: local('Ubuntu Medium Italic'), local('Ubuntu-MediumItalic'),
						url(${ubuntuMediumItalic}) format('truetype');
				}
				@font-face {
					font-family: 'Ubuntu';
					font-style: italic;
					font-weight: 700;
					font-display: swap;
					src: local('Ubuntu Bold Italic'), local('Ubuntu-BoldItalic'),
						url(${ubuntuBoldItalic}) format('truetype');
				}
				@font-face {
					font-family: 'Ubuntu';
					font-style: normal;
					font-weight: 300;
					font-display: swap;
					src: local('Ubuntu Light'), local('Ubuntu-Light'),
						url(${ubuntuLight}) format('truetype');
				}
				@font-face {
					font-family: 'Ubuntu';
					font-style: normal;
					font-weight: 400;
					font-display: swap;
					src: local('Ubuntu Regular'), local('Ubuntu-Regular'),
						url(${ubuntuRegular}) format('truetype');
				}
				@font-face {
					font-family: 'Ubuntu';
					font-style: normal;
					font-weight: 500;
					font-display: swap;
					src: local('Ubuntu Medium'), local('Ubuntu-Medium'),
						url(${ubuntuMedium}) format('truetype');
				}
				@font-face {
					font-family: 'Ubuntu';
					font-style: normal;
					font-weight: 700;
					font-display: swap;
					src: local('Ubuntu Bold'), local('Ubuntu-Bold'),
						url(${ubuntuBold}) format('truetype');
				}
			`}
		>
			<div
				style={{
					fontFamily: 'Ubuntu',
					fontWeight: 300,
					fontStyle: 'italic',
				}}
			>
				Ubuntu Light Italic
			</div>
			<div
				style={{
					fontFamily: 'Ubuntu',
					fontWeight: 500,
					fontStyle: 'italic',
				}}
			>
				Ubuntu Medium Italic
			</div>
			<div
				style={{
					fontFamily: 'Ubuntu',
					fontWeight: 700,
					fontStyle: 'italic',
				}}
			>
				Ubuntu Bold Italic
			</div>
			<div
				style={{
					fontFamily: 'Ubuntu',
					fontWeight: 300,
					fontStyle: 'normal',
				}}
			>
				Ubuntu Light
			</div>
			<div
				style={{
					fontFamily: 'Ubuntu',
					fontWeight: 400,
					fontStyle: 'normal',
				}}
			>
				Ubuntu Regular
			</div>
			<div
				style={{
					fontFamily: 'Ubuntu',
					fontWeight: 500,
					fontStyle: 'normal',
				}}
			>
				Ubuntu Medium
			</div>
			<div
				style={{
					fontFamily: 'Ubuntu',
					fontWeight: 700,
					fontStyle: 'normal',
				}}
			>
				Ubuntu Bold
			</div>
		</div>
	)
})
